// Menu item configuration types

// Defines where a menu item can be displayed
export enum MenuVisibility {
  SIDEBAR = 'sidebar',
  HEADER = 'header',
  BOTH = 'both',
  NONE = 'none',
}

// Base menu item interface
export interface BaseMenuItem {
  id: string;
  title: string;
  subtitle: string;
  to: string;
  default: boolean;
  beta?: boolean;
  disabled?: boolean;
  order: number;
  isExact?: boolean;
  collapsed?: string;
  widthCustom?: string;

  // Visibility configuration
  visibility: MenuVisibility;

  // Feature flag connection
  featureKey?: string; // Key that connects to a feature in WarehouseExtraSettings
  requiresFeature?: boolean; // If true, menu is only shown when feature is enabled
}

// Menu item for sidebar
export interface SidebarMenuItem extends BaseMenuItem {
  showInDemo?: boolean;
}

// Menu item for header
export interface HeaderMenuItem extends BaseMenuItem {
  isDemo?: boolean;
  showIfActive?: boolean;
  isPurchasing?: boolean;
  titleShort?: string;
}

// Union type for all menu items
export type MenuItem = SidebarMenuItem | HeaderMenuItem;

// Menu item service configuration
export interface MenuItemFeatureSettings {
  enabled: boolean;
  // Additional settings specific to the feature
  [key: string]: any;
}

// Extension to WarehouseExtraSettings
export interface MenuFeatureSettings {
  [featureKey: string]: MenuItemFeatureSettings;
}

// Menu order settings
export interface MenuOrderSettings {
  id: string;
  order: number;
}

// Menu configuration settings to store in WarehouseExtraSettings
export interface MenuConfigSettings {
  enabled: boolean;
  menuOrder?: MenuOrderSettings[];
}
